import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_BEGIN,
  REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_SUCCESS,
  REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_FAILURE,
  REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_DISMISS_ERROR,
} from './constants';

export function exportScInActionReportData(condition = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/exportSCInAction`, condition, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportScInActionReportDataError() {
  return {
    type: REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_DISMISS_ERROR,
  };
}

export function useExportScInActionReportData() {
  const dispatch = useDispatch();

  const { exportScInActionReportDataPending, exportScInActionReportDataError } = useSelector(
    state => ({
      exportScInActionReportDataPending: state.reports.exportScInActionReportDataPending,
      exportScInActionReportDataError: state.reports.exportScInActionReportDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportScInActionReportData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportScInActionReportDataError());
  }, [dispatch]);

  return {
    exportScInActionReportData: boundAction,
    exportScInActionReportDataPending,
    exportScInActionReportDataError,
    dismissExportScInActionReportDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportScInActionReportDataPending: true,
        exportScInActionReportDataError: null,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        exportScInActionReportDataPending: false,
        exportScInActionReportDataError: null,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        exportScInActionReportDataPending: false,
        exportScInActionReportDataError: action.data.error,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_REPORT_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportScInActionReportDataError: null,
      };

    default:
      return state;
  }
}
